import { RootState } from 'shared/store/store'
export const getGuides = (state: RootState) => state.guides
